/*eslint-disable */
import React, { useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import Button from 'components/Button'
import SubmitIcon from 'assets/icons/submit-icon'
import ArrowLeftLine from 'assets/icons/arrow-left-line'
import RemoveIcon from 'assets/icons/remove-icon16px'
import { MonitoringContext } from 'providers/monitoring'
import Modal from 'components/Modal'
import AutoSaveIcon from 'features/AutoSaveIcon'
import FlowRequestModal from 'components/FlowRequestModal'
import { useRequestQueue } from 'hooks/useRequestQueue'
import { showErrorToast, showSuccessToast } from 'utils/toast'
import { monitoringFinishPropose, requestDeleteMonitoringDraft } from 'api/monitoring'
import { NewSiteFooterButtonWrapper, NewSiteFooterRightPart, NewSiteFooterWrapper } from './style'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'
import ValidationProposalModal from './components/ValidationProposalModal'
import SubmitConfirmationModal from './components/SubmitConfirmationModal'
import PressureValidationModal from './components/pressureValidationModal'

const isSectionComplete = (section) => {
  if (typeof section === 'boolean') {
    return section
  }
  const values = Object.values(section || {})
  if (values.length === 0) return false

  return values.every((element) => element === true)
}
const getUncompletedSection = (validation, monitoring) => {
  const result = []
  if (!isSectionComplete(validation?.about)) {
    result.push('About')
  }

  if (
    !isSectionComplete(validation?.siteResponse ?? true) ||
    (monitoring?.response_evaluation === true && !validation?.siteResponse)
  ) {
    result.push('Response')
  }

  if (!isSectionComplete(validation?.siteState?.result ?? true)) {
    result.push('State')
  }

  if (validation?.oneTabRequired === false) {
    result.push('oneTabRequired')
  }

  if (!isSectionComplete(validation?.sitePressure?.result ?? true)) {
    result.push('Pressure')
  }

  return [...new Set(result)]
}

const Footer = () => {
  const history = useNavigate()
  const { monitoring, monitoringProposalFieldValidation, getMonitoringValidation, mergedParams, isEditable, checkPressureThreatsCompleted} =
    useContext(MonitoringContext)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalForDeletingOpen, setIsModalForDeletingOpen] = useState(false)
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false)
  const [isSubmitPressureModalOpen, setIsSubmitPressureModalOpen] = useState(false)
  const sections = getUncompletedSection(monitoringProposalFieldValidation, monitoring)
  const isLoading = useRequestQueue()

  function goBack() {
    history('/sites')
  }

  function openDeleteModal() {
    setIsModalForDeletingOpen(true)
  }

  async function deleteSite() {
    try {
      const data = await requestDeleteMonitoringDraft(mergedParams?.monitoring?.id)
      if (data?.error) {
        return showErrorToast(data.error, 'showBorder')
      }
      goBack()
    } catch (err) {
      throw new Error(err)
    }
  }
  const completedSections = []
  if (monitoringProposalFieldValidation?.siteState?.result) {
    completedSections.push('State')
  }
  if (monitoringProposalFieldValidation?.sitePressure?.result) {
    completedSections.push('Pressure')
  }
  if (isSectionComplete(monitoringProposalFieldValidation?.siteResponse)) {
    completedSections.push('Response')
  }

  const handleSubmitDialog = async () => {
    try {
      if(checkPressureThreatsCompleted){
        setIsSubmitPressureModalOpen(true)
      } else {
        const validateRes = await getMonitoringValidation()
        const freshSections = getUncompletedSection(validateRes, mergedParams?.monitoring?.id)
        if (freshSections.length > 0) {
          setIsModalOpen(true)
        } else {
          setIsSubmitModalOpen(true)
        }
      }
    } catch (error) {
      console.error('Validation failed:', error)
      showErrorToast('An error occurred during validation. Please try again.', 'showBorder')
    }
  }

  const handleSubmit = async () => {
    try {
      await monitoringFinishPropose(monitoring.id)
      showSuccessToast('Monitoring evaluation proposed successfully', 'showBorder')
      goBack()
    } catch (error) {
      console.error('Submission failed:', error)
      showErrorToast('An error occurred during submission. Please try again.', 'showBorder')
    }
  }

  return (
    <NewSiteFooterWrapper style={{ zIndex: '99999' }}>
      <div style={{ width: '35%' }}>
        <NewSiteFooterButtonWrapper onClick={goBack}>
          <Button height="40px" withIcon={true}>
            <ArrowLeftLine />
            <FormattedMessage id="backToSites" />
          </Button>
        </NewSiteFooterButtonWrapper>
      </div>
      <AutoSaveIcon loading={isLoading} time={'saved'} />
      {monitoring?.monitoring_status === SITE_STATUS_DRAFT_ID && (
        <NewSiteFooterRightPart>
          <NewSiteFooterButtonWrapper>
            <Button height="40px" withIcon={true} type="delist" onClick={openDeleteModal} isDisabled={!isEditable}>
              <RemoveIcon />
              <FormattedMessage id="deleteDraftBtn" />
            </Button>
            <Button
              dataTestId="submit-proposal-button"
              height="40px"
              withIcon={true}
              type="primary"
              onClick={handleSubmitDialog}
              isDisabled={!isEditable}
            >
              <SubmitIcon />
              <FormattedMessage id="submitEvaluation" />
            </Button>
          </NewSiteFooterButtonWrapper>
        </NewSiteFooterRightPart>
      )}
      <Modal
        width="496px"
        isOpen={isModalForDeletingOpen}
        toggleModal={setIsModalForDeletingOpen}
        modalTitleId="deleteDraft"
        zIndex={99999}
      >
        <FlowRequestModal
          cancelHandler={() => {
            setIsModalForDeletingOpen(false)
          }}
          confirmHandler={deleteSite}
          confirmBtnText="yesDelete"
          text={<FormattedMessage id="monitoringForDeletingDraft" />}
          item={mergedParams}
          approve={false}
        />
      </Modal>
      <Modal
        width="416px"
        toggleModal={setIsModalOpen}
        isOpen={isModalOpen && sections.length > 0}
        modalTitleId="unfinishedProposal"
        zIndex={99999}
      >
        <ValidationProposalModal sections={sections} toggleModal={setIsModalOpen} />
      </Modal>
      <Modal
        width="416px"
        toggleModal={setIsSubmitModalOpen}
        isOpen={isSubmitModalOpen && sections.length === 0}
        modalTitleId="submitEvaluation"
        zIndex={99999}
      >
        <SubmitConfirmationModal
          onBack={() => setIsSubmitModalOpen(false)}
          onSubmit={handleSubmit}
          completedSections={completedSections}
        />
      </Modal>
      <Modal
        width="416px"
        toggleModal={setIsSubmitPressureModalOpen}
        isOpen={isSubmitPressureModalOpen}
        modalTitleId="unfinishedProposal"
        zIndex={99999}
      >
        <PressureValidationModal
          toggleModal={() => setIsSubmitPressureModalOpen(false)}
        />
      </Modal>
    </NewSiteFooterWrapper>
  )
}

export default Footer
